var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"id":"default-app-bar","height":"64","app":"","flat":"","color":"primary"}},[_c('default-logo'),_c('v-spacer'),_c('default-account')],1)}
var staticRenderFns = []

export { render, staticRenderFns }